const makeVariant = ({ theme, variant, type, state }) => {
    return `color: ${theme.links.variant[variant][type][state].color}!important;
          border-color: ${theme.links.variant[variant][type][state].borderColor};
          background-color: ${theme.links.variant[variant][type][state].backgroundColor};
          text-decoration: none;
          outline: ${theme.links.variant[variant][type][state].outline} solid 1px;
          
          i {
            &:before{
              background-color: ${theme.links.variant[variant][type][state].color}!important;
            }
          }`;
};
const getLinkSize = ({ theme, icon, size }) => {
    return icon && icon.size ? `${icon.size}px` : theme.links.size[size].withoutText;
};
const getLinkPadding = ({ content }) => {
    return content ? '0px 12px' : '0';
};
const makeLink = ({ theme, linkoptions, content, icon }) => {
    const size = linkoptions && linkoptions.size || 'small';
    const type = linkoptions && linkoptions.type || 'link';
    const variant = linkoptions && linkoptions.variant || 'primary';
    const block = linkoptions && linkoptions.block || false;
    const position = (icon && icon.position) || 'center';
    const paddingByIcon = {
        large: '60px',
        medium: '42px',
        small: '34px',
    };
    const padding = {
        right: `0 ${paddingByIcon[size]} 0 8px`,
        left: `0 8px 0 ${paddingByIcon[size]}`,
        center: `0 8px 0 8px`
    };
    return `
    position: relative;
    border: 1px solid transparent;
    border-radius: 8px;
    font-weight: 600;
    transition: all .2s ease-in-out;
    cursor: pointer;
    display: ${block ? `block` : `inline-block`};
    text-align: center;
    padding: ${icon && content ? padding[icon.position] : getLinkPadding({ content })};
    font-size: ${theme.links.size[size].fontSize};
    line-height: ${theme.links.size[size].lineHeight};
    height: ${content ? `auto` : getLinkSize({ theme, icon, size })};
    width: ${content ? `auto` : getLinkSize({ theme, icon, size })};
    ${block ? `width: 100%!important;` : ``}
    ${makeVariant({ theme, variant, type, state: 'idle' })}
    &:hover {
      ${makeVariant({ theme, variant, type, state: 'hover' })}
    }
    &:active {
      ${makeVariant({ theme, variant, type, state: 'active' })}
    }
    &:focus:not(:active) {
      ${makeVariant({ theme, variant, type, state: 'focus' })}
    }
    &:disabled, 
    &:disabled:hover,
    &:disabled:active,
    &:disabled:focus{
      cursor: not-allowed;
      ${makeVariant({ theme, variant, type, state: 'disabled' })}
    }`;
};
export const makeLinkIcon = ({ position = 'left', content, linkoptions }) => {
    const { size } = linkoptions;
    const positionSize = {
        large: '15px',
        medium: '14px',
        small: '9px',
    };
    const iconSize = {
        large: '30px',
        medium: '24px',
        small: '18px',
    };
    const distance = !content || content === '' ? '50%' : positionSize[size];
    return `
      position: absolute;
      ${position}: ${distance};
      top: 50%;
      transform: translate(${!content || content === '' ? '-50%' : '0'}, -50%);  
      width: ${iconSize[size]};
      height: ${iconSize[size]};

      &:before{
        width: ${iconSize[size]};
        height: ${iconSize[size]};
      }`;
};
export const makeNativeLink = props => {
    return makeLink(props);
};
export const makeNotNativeLink = props => {
    return makeLink(props);
};
export const makeNoFollowLink = props => {
    return makeLink(props);
};
export const makeDisabledLink = props => {
    return makeLink(props);
};
export const makeAnchorLink = props => {
    return makeLink(props);
};
